export const exchangesValues = [
	"XNYS",
	"XNCM",
	"XNGS",
	"ARCX",
	"XNMS",
	"XNAS",
	"BATS",
	"XASE",
	"AQSE",
	"XLON",
	"XSWX",
	"XBRN",
	"XSTO",
	"XDRF",
	"BMEX",
	"XKRX",
	"XKOS",
	"XSES",
	"XSAU",
	"XLIS",
	"XWAR",
	"XOSL",
	"XAMS",
	"XMEX",
	"XLUX",
	"XJPX",
	"HMTF",
	"ETLX",
	"XMIL",
	"XDUB",
	"XNSE",
	"XBOM",
	"XHKG",
	"ASEX",
	"XFRA",
	"XBER",
	"XSTU",
	"XDUS",
	"XHAM",
	"XHAN",
	"XETR",
	"XMUN",
	"TGAT",
	"XPAR",
	"XCSE",
	"XSHE",
	"XSHG",
	"XTSX",
	"XTSE",
	"NEOE",
	"BVMF",
	"XBRU",
	"XWBO",
	"XASX",
	"XBUE",
	"XHEL"
];
